import React, { PureComponent } from "react";
import ReactMarkdown from "react-markdown";
import gql from "graphql-tag";
import { Mutation } from "react-apollo";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import classNames from "classnames";
import customRendererLink from "../../utils/custom-link-renderer";
import Heading from "../../components/heading/heading";
import Cta from "../../components/cta/cta";
import ReactMDE from "../../components/react-mde/react-mde";
import CommunityAnswer from "../../components/community-answer/community-answer";
import FormErrorMessage from "../../components/form-error-message/form-error-message";
import VoteButtons from "../../components/vote-buttons/vote-buttons";
import Head from "../../components/head-data/head-data";
import PostDetails from "../../components/post-details/post-details";
import AskWidget from "../../components/ask-widget/ask-widget";
import Tag from "../../components/tag/tag";

import { checkForAmountOfWords } from "../../utils/validation";
import QUESTION_QUERY from "../../queries/question-query";

import "./page-question.scss";

const POST_ANSWER_MUTATION = gql`
  mutation POST_ANSWER_MUTATION($body: String!, $id: ID!) {
    postAnswer(body: $body, id: $id) {
      success
    }
  }
`;

function HeadingRenderer(props) {
  if (props.level === 1) {
    return <h2>{props.children}</h2>;
  }

  const Heading = Markdown.renderers.heading;
  return <Heading {...props} />;
}

class PageQuestion extends PureComponent {
  constructor(props) {
    super(props);
    const correctAnswerFilter = props.answers.filter(
      (answer) => answer.markedCorrect === true
    );

    this.state = {
      answerBody: "",
      answerBodyValid: true,
      markingOfCorrectAnswerBlocked: false,
      correctAnswerId:
        correctAnswerFilter.length > 0 ? correctAnswerFilter[0].id : null,
    };
  }
  handleValueChange = (answerBody) => {
    this.setState({
      answerBody,
      bodyValid: true,
    });
  };

  toggleBlockOfMarkingCorrectAnswers = (bool) => {
    this.setState({
      markingOfCorrectAnswerBlocked: bool,
    });
  };

  markedCorrectAnswer = (correctAnswerId) => {
    this.toggleBlockOfMarkingCorrectAnswers(true);
    let newCorrectAnswerId = correctAnswerId;
    if (correctAnswerId === this.state.correctAnswerId) {
      newCorrectAnswerId = null;
    }
    this.setState({
      correctAnswerId: newCorrectAnswerId,
    });
  };

  checkAnswerFields = (submit) => {
    const { answerBody } = this.state;

    const newState = {};

    if (!checkForAmountOfWords(answerBody, 20)) {
      newState.answerBodyValid = false;
    }

    if (Object.keys(newState).length > 0) {
      return this.setState(newState);
    }

    submit();
  };

  render() {
    const {
      title,
      body,
      me,
      id,
      answers,
      slug,
      ratedUpKnowledgeItems,
      ratedDownKnowledgeItems,
      poster,
      toggleOverlay,
      createdAt,
      tags,
      query,
    } = this.props;

    const {
      answerBody,
      answerBodyValid,
      correctAnswerId,
      markingOfCorrectAnswerBlocked,
    } = this.state;

    const pageidxref = query.pageidxref;

    let refetchVariables = {};
    if (pageidxref) {
      refetchVariables.referencePageNumber = pageidxref;
    }

    const hasAlreadyAnswered =
      me && answers.filter((ans) => ans.poster.id === me.id).length > 0;
    const isOwnerOfQuestion = me && me.id === poster.id;

    return (
      <ReactCSSTransitionGroup
        transitionName="overlay"
        transitionAppear={true}
        component={React.Fragment}
        transitionAppearTimeout={500}
        transitionEnter={false}
        transitionLeave={false}
      >
        <Head
          title={title}
          description={body.slice(0, 160)}
          url={`https://www.foundercloud.com/the-nest/q/${slug}`}
        />
        <div className="page-question">
          <article className="page-question__inner">
            <div className="page-question__question">
              <div className="page-question__vote-buttons">
                <VoteButtons
                  ratedUpKnowledgeItems={ratedUpKnowledgeItems}
                  ratedDownKnowledgeItems={ratedDownKnowledgeItems}
                  myId={me ? me.id : null}
                  voteOnWhat="QUESTION"
                  referenceId={id}
                  posterId={poster.id}
                  refetchQueryName={
                    pageidxref ? "COMMUNITY_QUESTIONS_QUERY" : undefined
                  }
                  refetchQueryVariables={refetchVariables}
                  toggleOverlay={toggleOverlay}
                  disabled={isOwnerOfQuestion}
                />
              </div>
              <div
                className={classNames("page-question__heading", {
                  "page-question__heading--has-tags": tags.length > 0,
                })}
              >
                <Heading element="h1" copy={title} />
              </div>
              {tags.length > 0 && (
                <div className="page-question__tags">
                  {tags.map((tag) => (
                    <Tag key={tag.id} label={tag.label} hasHashTag />
                  ))}
                </div>
              )}
              <div className="page-question__content">
                <ReactMarkdown
                  source={body}
                  escapeHtml={false}
                  linkTarget="_blank"
                  renderers={{
                    heading: HeadingRenderer,
                    ...customRendererLink,
                  }}
                />
                <PostDetails
                  me={me}
                  itemId={id}
                  poster={poster}
                  type="QUESTION"
                  createdAt={createdAt}
                />
              </div>
              {answers.length > 0 && (
                <div className="page-question__answers">
                  <h2>
                    {`${answers.length} answer${answers.length > 1 ? "s" : ""}`}
                    :
                  </h2>
                  {answers.map((answer) => (
                    <CommunityAnswer
                      {...answer}
                      key={answer.id}
                      questionId={id}
                      me={me}
                      isOwnerOfQuestion={isOwnerOfQuestion}
                      correctAnswerId={correctAnswerId}
                      markedCorrectAnswer={this.markedCorrectAnswer}
                      toggleBlockOfMarkingCorrectAnswers={
                        this.toggleBlockOfMarkingCorrectAnswers
                      }
                      markingOfCorrectAnswerBlocked={
                        markingOfCorrectAnswerBlocked
                      }
                      pageSlug={slug}
                      toggleOverlay={toggleOverlay}
                    />
                  ))}
                </div>
              )}
            </div>
            {me && !hasAlreadyAnswered && (
              <Mutation
                mutation={POST_ANSWER_MUTATION}
                variables={{
                  body: answerBody,
                  id,
                }}
                refetchQueries={[
                  {
                    query: QUESTION_QUERY,
                    variables: { slug },
                  },
                ]}
              >
                {(postAnswer, { error, loading, called }) => {
                  return (
                    <div className="page-question__post-answer">
                      <h3>
                        Know a good answer or solution? Post it here just below
                      </h3>
                      <FormErrorMessage
                        isValid={answerBodyValid}
                        validationErrorMsg={
                          "Please describe your answer in more detail"
                        }
                      />
                      <ReactMDE
                        handleValueChange={this.handleValueChange}
                        body={answerBody}
                        placeholder="Write your answer here"
                      />
                      <Cta
                        disabled={loading}
                        tag="button"
                        type="button"
                        text={loading ? "Submitting..." : "Submit answer"}
                        onClick={() => this.checkAnswerFields(postAnswer)}
                      />
                    </div>
                  );
                }}
              </Mutation>
            )}
          </article>
        </div>
        <div className="page-question__ask">
          <AskWidget pageidxref={pageidxref} me={me} />
        </div>
      </ReactCSSTransitionGroup>
    );
  }
}

export default PageQuestion;
